export class Translator {
  constructor() {
    const data = document.querySelector(".dataentry-namespaces");
    if (data) {
      this.namespaces = JSON.parse(data.dataset.namespaces);
    }
  }

  /**
   *
   * @param key
   * @param replacements
   * @returns {*}
   */
  translate(key, replacements) {
    if (!key || !window.Language) {
      return "";
    }

    for (let namespace in this.namespaces) {
      let prefix = this.namespaces[namespace];

      if (window.Language[prefix + "." + key]) {
        let str = window.Language[prefix + "." + key];

        if (replacements) {
          for (let item in replacements) {
            if (replacements.hasOwnProperty(item)) {
              str = str.replace(new RegExp(item, "g"), replacements[item]);
            }
          }
        }
        return str;
      }
    }

    return key;
  }
}
